<h1 mat-dialog-title>Action</h1>
<mat-dialog-content>
    <a [href]="data.href" target="_blank" class="location-link" (click)="closeDialog()">
        Take action {{data.actionName}} for
        <strong *ngIf="data.identityFieldValue; else primaryKeysList">{{data.identityFieldValue}}</strong>
        <ng-template #primaryKeysList>
            <strong *ngFor="let primaryKey of data.primaryKeys | keyvalue; let last = last">
                {{primaryKey.key}} = {{primaryKey.value}}<span *ngIf="!last">,</span>
            </strong>
        </ng-template>.
    </a>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
